import React from 'react';
import pt from 'prop-types';
import MenuForm from 'components/storefront/menu-form';

export default class EditMenuModalPage extends React.Component {
  static propTypes = {
    record: pt.object,
    loaded: pt.bool,
    edited: pt.bool,
    onSubmitRecord: pt.func,
    onDelete: pt.func,
  };

  static contextTypes = {
    openModal: pt.func.isRequired,
    closeModal: pt.func.isRequired,
  };

  menuFormRef = null;

  onClickSubmit = (event) => {
    event.preventDefault();
    this.menuFormRef?.submit();
  };

  onCloseModal = (event) => {
    if (this.props.edited) {
      event.preventDefault();

      this.context.openModal('ConfirmRouteLeave', {
        onConfirm: () => {
          this.context.closeModal();
        },
      });
    }
  };

  render() {
    const { loaded, record, onDelete } = this.props;

    return (
      <MenuForm
        {...this.props}
        modalProps={{
          title: record && <span>{record.name}</span>,
          width: 800,
          loading: !loaded,
          localized: true,
          tapout: false,
          onClose: this.onCloseModal,
          actions: [
            {
              label: 'Save menu',
              onClick: this.onClickSubmit,
              type: 'default',
            },
            {
              label: 'Delete menu',
              onClick: onDelete,
              type: 'cancel-danger left',
            },
          ],
        }}
        onRef={(ref) => (this.menuFormRef = ref)}
      />
    );
  }
}
